<template>
  <div
    class="g-checkbox__wrapper"
    :class="[size?size:'m',checked?'checked':'unchecked']"
    @click="$emit('click', $event)"
  >
    <svg
      preserveAspectRatio="xMidYMid meet"
      x="0px"
      y="0px"
      widht="100%"
      height="100%"
      viewBox="0 0 56.7 56.7"
    >
      <polygon
        points="47.9,11.8 44.9,8.8 28.3,25.3 11.8,8.8 8.8,11.8 25.3,28.3 8.8,44.9 11.8,47.9 28.3,31.4 44.9,47.9 
	47.9,44.9 31.4,28.3 "
      ></polygon>
      <path d="M0,0v56.7h56.7V0H0z M53.9,53.9h-51v-51h51V53.9z"></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: "g-checkbox",
  props: ["checked", "size"],
  data() {
    return {};
  }
};
</script>
 
<style lang="scss" scoped>
.g-checkbox__wrapper {
  cursor: pointer;
  &:hover {
    background-color: $blue4;
  }
  line-height: 0;
  &.m {
    width: 18px;
    height: 18px;
  }

  &.s {
    width: 15px;
    height: 15px;
  }

  path {
    fill: #000;
  }
  &.checked {
    polygon {
      fill: #000;
    }
  }
  &.unchecked {
    polygon {
      fill: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// Checkbox.vue?77f767a1